import { getMomentDate, getLocalDateTimeFromUtc } from '../../Utils/dates.util';
import moment, { Moment } from 'moment-timezone';
import { SelectValue } from '../Base/Select/Select';
import { RepeatInterval } from '../../Modules/ServiceSchedule/Enums/RepeatInterval.enum';

export const calculateTimesFromValues = (values: {
	date: any;
	individualTime: boolean;
	workingTime: any;
	workingHours: any;
	workingHoursExtra: any;
	timeFrom: any;
	timeTo: any;
}) => {
	const { date, individualTime, workingTime, workingHours, workingHoursExtra } =
		values;

	let { timeTo, timeFrom } = values;

	const dateTo = date.clone().set({
		hour: 23,
		minute: 59,
		second: 59,
	});
	const dateFrom = date.set({
		hour: 0,
		minute: 0,
		second: 0,
	});

	if (individualTime) {
		const timeFromMoment = moment(timeFrom);
		const timeToMoment = moment(timeTo);
		timeFrom = date.clone().set({
			hour: timeFromMoment.hours(),
			minute: timeFromMoment.minutes(),
			second: timeFromMoment.seconds(),
		});
		timeTo = date.clone().set({
			hour: timeToMoment.hours(),
			minute: timeToMoment.minutes(),
			second: timeToMoment.seconds(),
		});
	} else {
		if (workingTime === 'SHIFT') {
			timeFrom = workingHours.from;
			timeTo = workingHours.to;
		} else if (workingTime === 'SHIFT_EXTRA') {
			timeFrom = workingHoursExtra.from;
			timeTo = workingHoursExtra.to;
		}
	}

	return { dateTo, dateFrom, timeTo, timeFrom };
};

interface BuildScheduleItemProps {
	date: Moment;
	timeFrom: Moment;
	timeTo: Moment;
	price?: {
		priceWithVat: number;
		currency: string;
		vatRate: number;
	};
	currency?: string;
	vatRate?: number;
	workplaceMembers?: SelectValue[];
	guaranteedTime?: number;
	repeatInterval?: SelectValue;
	repeatTo?: any;
	specificDaysInWeek?: {
		mon: boolean;
		tue: boolean;
		wed: boolean;
		thu: boolean;
		fri: boolean;
		sat: boolean;
		sun: boolean;
	};
	workplaceCaseTypeIds?: string[];
	limitMaxActiveCases?: boolean;
	maxActiveCases?: number;
}

export const prepareDateWithUTCDrift = (date: Moment, time: Moment): Moment => {
	return getLocalDateTimeFromUtc(
		date.clone().format('YYYY-MM-DDTHH:mm:ss'),
		moment(time).format('HH:mmZ'),
	);
};

export const buildScheduleItem = (values: BuildScheduleItemProps) => {
	const {
		date,
		timeFrom,
		timeTo,
		workplaceMembers,
		price,
		currency,
		vatRate,
		guaranteedTime,
		repeatInterval,
		repeatTo,
		specificDaysInWeek,
		workplaceCaseTypeIds,
		limitMaxActiveCases,
		maxActiveCases,
	} = values;

	const days: Record<string, string> = {
		Monday: 'mon',
		Tuesday: 'tue',
		Wednesday: 'wed',
		Thursday: 'thu',
		Friday: 'fri',
		Saturday: 'sat',
		Sunday: 'sun',
	};

	const momentDate = getMomentDate(date);

	const timeFromNew = getLocalDateTimeFromUtc(
		momentDate
			.clone()
			.add(momentDate.utcOffset(), 'minutes')
			.format('YYYY-MM-DDTHH:mm:ss'),
		moment(timeFrom).format('HH:mmZ'),
	).format('HH:mmZ');
	let timeToNew = getLocalDateTimeFromUtc(
		momentDate
			.clone()
			.add(momentDate.utcOffset(), 'minutes')
			.format('YYYY-MM-DDTHH:mm:ss'),
		moment(timeTo).format('HH:mmZ'),
	).format('HH:mmZ');

	const [, timeFromNewTz] = timeFromNew.split(/(?=[+-])/);
	const [timeToNewTime, timeToNewTz] = timeToNew.split(/(?=[+-])/);

	if (parseInt(timeToNewTz) !== parseInt(timeFromNewTz)) {
		timeToNew = `${timeToNewTime}${timeFromNewTz}`;
	}

	const obj: any = {
		day: days[date.format('dddd')],
		timeFrom: timeFromNew,
		timeTo: timeToNew,
		canOrderImmediate: true,
		interval: guaranteedTime || null,
		price,
	};

	if (workplaceMembers) {
		obj['workplaceMemberIds'] = values?.workplaceMembers?.map(wm => wm.value);
	}

	if (workplaceCaseTypeIds) {
		obj['workplaceCaseTypeIds'] = workplaceCaseTypeIds;
	}

	if (repeatInterval && repeatInterval.value != RepeatInterval.NEVER) {
		obj['repeatInterval'] = repeatInterval.value;
		obj['repeatTo'] = getMomentDate(repeatTo).format('YYYY-MM-DD');
		if (
			repeatInterval.value === RepeatInterval.SPECIFIC_DAYS_IN_WEEK &&
			specificDaysInWeek
		) {
			obj['specificDaysInWeek'] = specificDaysInWeek;
		}
	}

	if (limitMaxActiveCases) {
		obj['maxActiveCases'] = values.maxActiveCases;
	}

	return obj;
};
